import { MediaFile, MediaFileBundle } from 'elements-sdk'

export function isBundle (item: MediaFile|MediaFileBundle): item is MediaFileBundle {
  return !('isDir' in item)
}
